import * as yup from 'yup';

const validationSchema = yup.object().shape({
  city: yup.string().required('Please select a state.'),
  llcValue: yup.string().required('Please select an entity type'),
});

export default validationSchema;
